// if (!customElements.get('product-form')) {
//   class ProductForm extends HTMLElement {
//     constructor() {
//       super();
//       if (this.hasChildNodes()) this.init();
//     }

//     init() {
//       this.form = this.querySelector('.js-product-form');
//       if (this.form) {
//         this.form.querySelector('[name="id"]').disabled = false;
//         this.cartDrawer = document.querySelector('cart-drawer');
//         this.submitBtn = this.querySelector('[name="add"]');

//         if (theme.settings.afterAtc !== 'no-js') {
//           this.form.addEventListener('submit', this.handleSubmit.bind(this));
//         }
//       }

//       const buyNowBtn = this.querySelector('.btn--custom-buy-now');
//       if (buyNowBtn) {
//         buyNowBtn.addEventListener('click', this.customBuyNowHandler.bind(this));
//       }
//     }

//     getFreeGiftVariantId() {
//       const freeGiftField =
//         this.querySelector('#freegiftproduct') ||
//         this.querySelector('.freegiftproduct') ||
//         this.querySelector('[name="freegiftproduct"]');
   
//       if (!freeGiftField) return null;

//       const rawValue = String(
//         freeGiftField.value ||
//         freeGiftField.getAttribute('value') ||
//         freeGiftField.dataset.variantId ||
//         ''
//       ).trim();

//       if (!rawValue || !/^\d+$/.test(rawValue)) return null;

//       return Number(rawValue);
//     }

//     getErrorMessage(data, fallback = 'Something went wrong.') {
//       let error =
//         typeof data?.description === 'string'
//           ? data.description
//           : data?.message || fallback;

//       if (data?.errors && typeof data.errors === 'object') {
//         error = Object.entries(data.errors).map(([, value]) => {
//           if (Array.isArray(value)) return value.join(', ');
//           return value;
//         });
//       }

//       return error;
//     }

//     async getCart() {
//       const response = await fetch(`${theme.routes.cart}.js`);
//       if (!response.ok) throw new Error(`Cart fetch failed: ${response.status}`);
//       return response.json();
//     }

//     async addFreeGiftIfNeeded(existingCart, sections = '') {
//       const freeGiftVariantId = this.getFreeGiftVariantId();
//       if (!freeGiftVariantId) return null;

//       const alreadyInCart = existingCart.items.some((item) => {
//         return Number(item.variant_id) === freeGiftVariantId || Number(item.id) === freeGiftVariantId;
//       });

//       if (alreadyInCart) return null;

//       try {
//         const giftFormData = new FormData();
//         giftFormData.append('id', freeGiftVariantId);
//         giftFormData.append('quantity', 1);

//         if (sections) {
//           giftFormData.append('sections_url', window.location.pathname);
//           giftFormData.append('sections', sections);
//         }

//         const giftResponse = await fetch(theme.routes.cartAdd, {
//           method: 'POST',
//           headers: {
//             Accept: sections ? 'application/javascript' : 'application/json',
//             'X-Requested-With': 'XMLHttpRequest'
//           },
//           body: giftFormData
//         });
 
//         const giftData = await giftResponse.json();
//         const giftError = this.getErrorMessage(giftData, 'Free product could not be added.');

//         if (!giftResponse.ok || giftData.status) {
//           alert(Array.isArray(giftError) ? giftError.join('\n') : giftError);
//           return null;
//         }

//         return giftData;
//       } catch (error) {
//         console.log('Free gift add error:', error);
//         alert('Free product could not be added, but the main product was added successfully.');
//         return null;
//       }
//     }

//     refreshCartUI(responseData) {
//       ProductForm.updateCartIcon(responseData);

//       const quickAddDrawer = this.closest('quick-add-drawer');
//       if (quickAddDrawer) quickAddDrawer.addedToCart();

//       if (this.cartDrawer) {
//         this.cartDrawer.renderContents(
//           responseData,
//           !quickAddDrawer && theme.settings.afterAtc === 'drawer'
//         );
//       } else if (window.location.pathname === theme.routes.cart) {
//         const cartItems = document.querySelector('cart-items');
//         if (cartItems) {
//           if (cartItems.dataset.empty === 'true') {
//             window.location.reload();
//           } else {
//             cartItems.refresh();
//           }
//         }
//       }
//     }
  
//     async customBuyNowHandler(evt) {
//       if (evt) evt.preventDefault();

//       const loader = this.querySelector('#buy-now-loader');
//       const buyNowBtn = this.querySelector('.btn--custom-buy-now');
//       if (!this.form || !buyNowBtn) return;

//       if (buyNowBtn.getAttribute('aria-disabled') === 'true' || buyNowBtn.disabled) return;

//       try {
//         buyNowBtn.setAttribute('aria-disabled', 'true');
//         if (loader) loader.style.display = 'flex';

//         const formData = new FormData(this.form);

//         const mainResponse = await fetch(theme.routes.cartAdd, {
//           method: 'POST',
//           headers: {
//             Accept: 'application/json',
//             'X-Requested-With': 'XMLHttpRequest'
//           },
//           body: formData
//         });

//         const mainData = await mainResponse.json();
//         const mainError = this.getErrorMessage(mainData, 'Main product could not be added.');

//         if (!mainResponse.ok || mainData.status) {
//           this.setErrorMsgState(mainError);
//           alert(Array.isArray(mainError) ? mainError.join('\n') : mainError);
//           return;
//         }

//         const tempCart = await this.getCart();
//         await this.addFreeGiftIfNeeded(tempCart);

//         window.location.href = '/checkout';
//       } catch (error) {
//         console.log('Buy Now error:', error);
//         alert('Something went wrong. Please try again.');
//       } finally {
//         buyNowBtn.removeAttribute('aria-disabled');
//         if (loader) loader.style.display = 'none';
//       }
//     } 
 
//     async handleSubmit(evt) {
//       if (evt.target.id === 'product-signup_form') return;

//       evt.preventDefault();

//       if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

//       if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
//         window.navigator.vibrate(100);
//       }
 
//       this.errorMsg = null;
//       this.setErrorMsgState();

//       this.submitBtn.setAttribute('aria-disabled', 'true');
//       this.submitBtn.classList.add('is-loading');

//       const formData = new FormData(this.form);

//       let sections = 'cart-icon-bubble';
//       if (this.cartDrawer) {
//         sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
//       }
 
//       formData.append('sections_url', window.location.pathname);
//       formData.append('sections', sections);

//       const fetchRequestOpts = {
//         method: 'POST',
//         headers: {
//           Accept: 'application/javascript',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: formData
//       };
 
//       try {
//         const oldCartData = await this.getCart();

//         const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
//         const data = await response.json();
//         const error = this.getErrorMessage(data);

//         if (data.status) this.setErrorMsgState(error);
//         if (!response.ok || data.status) {
//           throw new Error(Array.isArray(error) ? error.join(', ') : error);
//         }

//         const tempCart = {
//           ...oldCartData,
//           items: [...oldCartData.items]
//         };

//         const existingMain = tempCart.items.find(
//           (item) => Number(item.variant_id) === Number(data.variant_id)
//         );

//         if (existingMain) {
//           existingMain.quantity += data.quantity || 1;
//         } else {
//           tempCart.items.push({
//             variant_id: data.variant_id,
//             id: data.variant_id,
//             quantity: data.quantity || 1
//           });
//         }

//         const freeGiftResponse = await this.addFreeGiftIfNeeded(tempCart, sections);

//         this.refreshCartUI(freeGiftResponse || data);

//         if (theme.settings.afterAtc === 'page') {
//           setTimeout(() => {
//             window.location.href = theme.routes.cart;
//           }, 300);
//           return;
//         }

//         const itemInOldCart = oldCartData.items.find(
//           (item) => Number(item.variant_id) === Number(data.variant_id)
//         );

//         if (itemInOldCart) {
//           this.dispatchEvent(new CustomEvent('on:line-item:change', {
//             bubbles: true,
//             detail: {
//               cart: null,
//               variantId: data.variant_id,
//               oldQuantity: itemInOldCart.quantity,
//               newQuantity: itemInOldCart.quantity + (data.quantity || 1)
//             }
//           }));
//         } else {
//           this.dispatchEvent(new CustomEvent('on:cart:add', {
//             bubbles: true,
//             detail: {
//               cart: null,
//               variantId: data.variant_id
//             }
//           }));
//         }
//       } catch (error) {
//         console.log(error);

//         this.dispatchEvent(new CustomEvent('on:cart:error', {
//           bubbles: true,
//           detail: {
//             error: this.errorMsg?.textContent || error.message
//           }
//         }));

//         if (this.cartDrawer) this.cartDrawer.refresh(true);
//       } finally {
//         this.submitBtn.classList.add('is-success');
//         this.submitBtn.removeAttribute('aria-disabled');

//         setTimeout(() => {
//           this.submitBtn.classList.remove('is-loading');
//           this.submitBtn.classList.remove('is-success');
//         }, 1400);
//       }
//     }

//     static updateCartIcon(response) {
//       const cartIconBubble = document.getElementById('cart-icon-bubble');
//       if (cartIconBubble && response.sections && response.sections['cart-icon-bubble']) {
//         cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
//       } 
//     }

//     setErrorMsgState(error = false) {
//       this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
//       if (!this.errorMsg) return;

//       this.errorMsg.hidden = !error;

//       if (error) {
//         this.errorMsg.innerHTML = '';
//         const errorArray = Array.isArray(error) ? error : [error];

//         errorArray.forEach((err, index) => {
//           if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
//           this.errorMsg.insertAdjacentText('beforeend', err);
//         });
//       }
//     }
//   }

//   customElements.define('product-form', ProductForm);
// } 

if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');

      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;

        this.cartDrawer =
          document.querySelector('cart-drawer');

        this.submitBtn =
          this.querySelector('[name="add"]');

        if (
          theme.settings.afterAtc !== 'no-js'
        ) {
          this.form.addEventListener(
            'submit',
            this.handleSubmit.bind(this)
          );
        }
      }

      const buyNowBtn =
        this.querySelector(
          '.btn--custom-buy-now'
        );

      if (buyNowBtn) {
        buyNowBtn.addEventListener(
          'click',
          this.customBuyNowHandler.bind(this)
        );
      }
    }

    /*
     * ============================================================
     * GET FREE GIFT VARIANT
     * ============================================================
     */
    getFreeGiftVariantId() {
      const freeGiftField =
        this.querySelector('#freegiftproduct') ||
        this.querySelector('.freegiftproduct') ||
        this.querySelector(
          '[name="freegiftproduct"]'
        );

      if (!freeGiftField) return null;

      const rawValue = String(
        freeGiftField.value ||
        freeGiftField.getAttribute('value') ||
        freeGiftField.dataset.variantId ||
        ''
      ).trim();

      if (
        !rawValue ||
        !/^\d+$/.test(rawValue)
      ) {
        return null;
      }

      return Number(rawValue);
    }

    /*
     * ============================================================
     * GET ERROR MESSAGE
     * ============================================================
     */
    getErrorMessage(
      data,
      fallback = 'Something went wrong.'
    ) {
      let error =
        typeof data?.description === 'string'
          ? data.description
          : data?.message || fallback;

      if (
        data?.errors &&
        typeof data.errors === 'object'
      ) {
        error = Object.entries(
          data.errors
        ).map(([, value]) => {
          if (
            Array.isArray(value)
          ) {
            return value.join(', ');
          }

          return value;
        });
      }

      return error;
    }

    /*
     * ============================================================
     * GET CART
     * ============================================================
     */
    async getCart() {
      const response =
        await fetch(
          `${theme.routes.cart}.js`,
          {
            headers: {
              Accept:
                'application/json'
            },
            cache: 'no-store'
          }
        );

      if (!response.ok) {
        throw new Error(
          `Cart fetch failed: ${response.status}`
        );
      }

      return response.json();
    }

    /*
     * ============================================================
     * DATE VALIDATION
     * ============================================================
     */
    freeGiftDateIsValid(
      startDateText,
      endDateText
    ) {
      const now = new Date();

      if (startDateText) {
        const startDate =
          new Date(
            startDateText +
            ' 00:00:00'
          );

        if (
          !Number.isNaN(
            startDate.getTime()
          ) &&
          now < startDate
        ) {
          return false;
        }
      }

      if (endDateText) {
        const endDate =
          new Date(
            endDateText +
            ' 23:59:59'
          );

        if (
          !Number.isNaN(
            endDate.getTime()
          ) &&
          now > endDate
        ) {
          return false;
        }
      }

      return true;
    }

    /*
     * ============================================================
     * CHECK FREE GIFT ITEM
     * ============================================================
     */
    isFreeGiftItem(item) {
      if (!item) return false;

      const properties =
        item.properties || {};

      return (
        properties['_auto_free_gift_rule'] ||
        properties['_is_free_gift'] === 'true'
      );
    }

    /*
     * ============================================================
     * GET QUALIFYING CART TOTAL
     * ============================================================
     *
     * Free gifts are excluded from the calculation.
     *
     * Shopify prices are already in cents.
     *
     * $99 = 9900
     * ============================================================
     */
    getQualifyingCartTotal(cart) {
      if (
        !cart ||
        !Array.isArray(cart.items)
      ) {
        return 0;
      }

      let total = 0;

      cart.items.forEach(
        (item) => {
          /*
           * Never count a free gift toward
           * the price threshold.
           */
          if (
            this.isFreeGiftItem(item)
          ) {
            return;
          }

          let linePrice = 0;

          if (
            item.final_line_price != null
          ) {
            linePrice =
              Number(
                item.final_line_price
              );
          } else if (
            item.line_price != null
          ) {
            linePrice =
              Number(
                item.line_price
              );
          }

          if (
            Number.isFinite(
              linePrice
            )
          ) {
            total += linePrice;
          }
        }
      );

      return Math.max(
        total,
        0
      );
    }

    /*
     * ============================================================
     * GET MATCHING FREE GIFT RULE
     * ============================================================
     *
     * Gift 2 is checked first.
     * Gift 1 is checked second.
     *
     * COLLECTION:
     * Only collection membership matters.
     *
     * PRICE:
     * Only price threshold matters.
     * ============================================================
     */
    getMatchingFreeGiftRule(
      cart,
      addedVariantId
    ) {
      if (
        !window.freeGiftRules ||
        !Array.isArray(
          window.freeGiftRules
        )
      ) {
        console.log(
          '[Free Gift] Rules unavailable.'
        );

        return null;
      }

      if (!cart) {
        return null;
      }

      /*
       * Get the added product from the cart.
       */
      const addedItem =
        cart.items.find(
          (item) =>
            Number(
              item.variant_id
            ) ===
            Number(
              addedVariantId
            )
        );

      /*
       * ==========================================================
       * IMPORTANT:
       *
       * window.freeGiftRules is already ordered:
       *
       * Gift 2
       * Gift 1
       *
       * Therefore the first valid rule wins.
       * ==========================================================
       */
      for (
        let i = 0;
        i <
        window.freeGiftRules.length;
        i++
      ) {
        const rule =
          window.freeGiftRules[i];

        if (!rule.enabled) {
          console.log(
            '[Free Gift] Rule disabled:',
            rule.id
          );

          continue;
        }

        if (
          !rule.freeGiftVariantId
        ) {
          console.log(
            '[Free Gift] No gift variant:',
            rule.id
          );

          continue;
        }

        if (
          !this.freeGiftDateIsValid(
            rule.startDate,
            rule.endDate
          )
        ) {
          console.log(
            '[Free Gift] Date invalid:',
            rule.id
          );

          continue;
        }

        /*
         * ========================================================
         * COLLECTION RULE
         * ========================================================
         *
         * Price is completely ignored.
         */
        if (
          rule.condition ===
          'collection'
        ) {
          if (
            !Array.isArray(
              rule.eligibleProductIds
            ) ||
            !rule.eligibleProductIds
              .length
          ) {
            continue;
          }

          if (!addedItem) {
            continue;
          }

          const eligibleProductIds =
            rule.eligibleProductIds.map(
              Number
            );

          const productMatches =
            eligibleProductIds.includes(
              Number(
                addedItem.product_id
              )
            );

          if (
            productMatches
          ) {
            console.log(
              '[Free Gift] COLLECTION rule matched:',
              rule.id
            );

            return rule;
          }

          /*
           * This rule does NOT match.
           * Continue to Gift 1 if this was Gift 2.
           */
          continue;
        }

        /*
         * ========================================================
         * PRICE RULE
         * ========================================================
         *
         * Collection is completely ignored.
         */
        if (
          rule.condition ===
          'price'
        ) {
          const qualifyingCartTotal =
            this.getQualifyingCartTotal(
              cart
            );

          const threshold =
            Number(
              rule.freeGiftPrice ||
              0
            );

          console.log(
            '[Free Gift] PRICE CHECK:',
            {
              ruleId:
                rule.id,

              qualifyingCartTotal,

              qualifyingCartTotalFormatted:
                (
                  qualifyingCartTotal /
                  100
                ).toFixed(2),

              threshold,

              thresholdFormatted:
                (
                  threshold /
                  100
                ).toFixed(2)
            }
          );

          if (
            threshold > 0 &&
            qualifyingCartTotal >=
              threshold
          ) {
            console.log(
              '[Free Gift] PRICE rule matched:',
              rule.id
            );

            return rule;
          }

          /*
           * Threshold not reached.
           *
           * Continue to next rule.
           */
          console.log(
            '[Free Gift] PRICE threshold not reached:',
            rule.id
          );

          continue;
        }
      }

      console.log(
        '[Free Gift] No matching rule.'
      );

      return null;
    }

    /*
     * ============================================================
     * ADD FREE GIFT
     * ============================================================
     *
     * This function is ONLY used by BUY NOW.
     *
     * Normal ATC uses the existing CartWatcher /
     * addAutoFreeGiftIfNeeded() system.
     *
     * This prevents duplicate gifts.
     * ============================================================
     */
    async addFreeGiftIfNeeded(
      existingCart,
      addedVariantId
    ) {
      if (
        !existingCart ||
        !Array.isArray(
          existingCart.items
        )
      ) {
        return null;
      }

      const freeGiftVariantId =
        this.getFreeGiftVariantId();

      if (!freeGiftVariantId) {
        console.log(
          '[Free Gift] No free gift variant configured.'
        );

        return null;
      }

      /*
       * Don't add another gift if the same
       * gift already exists.
       */
      const alreadyInCart =
        existingCart.items.some(
          (item) => {
            return (
              Number(
                item.variant_id
              ) ===
                Number(
                  freeGiftVariantId
                ) ||
              Number(item.id) ===
                Number(
                  freeGiftVariantId
                )
            );
          }
        );

      if (alreadyInCart) {
        console.log(
          '[Free Gift] Gift already in cart.'
        );

        return null;
      }

      /*
       * Find the ACTUAL matching rule.
       */
      const freeGiftRule =
        this.getMatchingFreeGiftRule(
          existingCart,
          addedVariantId
        );

      if (!freeGiftRule) {
        console.log(
          '[Free Gift] No matching rule. Gift will not be added.'
        );

        return null;
      }

      try {
        const giftFormData =
          new FormData();

        giftFormData.append(
          'id',
          freeGiftVariantId
        );

        giftFormData.append(
          'quantity',
          1
        );

        /*
         * Mark the item as an automatic
         * free gift.
         */
        giftFormData.append(
          'properties[_is_free_gift]',
          'true'
        );

        giftFormData.append(
          'properties[_auto_free_gift_rule]',
          freeGiftRule.id
        );

        console.log(
          '[Free Gift] Adding ONE gift:',
          {
            rule:
              freeGiftRule.id,

            condition:
              freeGiftRule.condition,

            variantId:
              freeGiftVariantId
          }
        );

        const giftResponse =
          await fetch(
            theme.routes.cartAdd,
            {
              method: 'POST',
              headers: {
                Accept:
                  'application/json',

                'X-Requested-With':
                  'XMLHttpRequest'
              },
              body:
                giftFormData
            }
          );

        const giftData =
          await giftResponse.json();

        const giftError =
          this.getErrorMessage(
            giftData,
            'Free product could not be added.'
          );

        if (
          !giftResponse.ok ||
          giftData.status
        ) {
          console.log(
            '[Free Gift] Gift add failed:',
            giftData
          );

          alert(
            Array.isArray(
              giftError
            )
              ? giftError.join('\n')
              : giftError
          );

          return null;
        }

        console.log(
          '[Free Gift] ONE free gift added successfully.'
        );

        return giftData;
      } catch (error) {
        console.log(
          '[Free Gift] Gift add error:',
          error
        );

        alert(
          'Free product could not be added, but the main product was added successfully.'
        );

        return null;
      }
    }

    /*
     * ============================================================
     * REFRESH CART UI
     * ============================================================
     */
    refreshCartUI(
      responseData
    ) {
      ProductForm.updateCartIcon(
        responseData
      );

      const quickAddDrawer =
        this.closest(
          'quick-add-drawer'
        );

      if (quickAddDrawer) {
        quickAddDrawer.addedToCart();
      }

      if (this.cartDrawer) {
        this.cartDrawer.renderContents(
          responseData,
          !quickAddDrawer &&
            theme.settings.afterAtc ===
              'drawer'
        );
      } else if (
        window.location.pathname ===
        theme.routes.cart
      ) {
        const cartItems =
          document.querySelector(
            'cart-items'
          );

        if (cartItems) {
          if (
            cartItems.dataset
              .empty === 'true'
          ) {
            window.location.reload();
          } else {
            cartItems.refresh();
          }
        }
      }
    }

    /*
     * ============================================================
     * BUY NOW
     * ============================================================
     */
    async customBuyNowHandler(
      evt
    ) {
      if (evt) {
        evt.preventDefault();
      }

      const loader =
        this.querySelector(
          '#buy-now-loader'
        );

      const buyNowBtn =
        this.querySelector(
          '.btn--custom-buy-now'
        );

      if (
        !this.form ||
        !buyNowBtn
      ) {
        return;
      }

      if (
        buyNowBtn.getAttribute(
          'aria-disabled'
        ) === 'true' ||
        buyNowBtn.disabled
      ) {
        return;
      }

      try {
        buyNowBtn.setAttribute(
          'aria-disabled',
          'true'
        );

        if (loader) {
          loader.style.display =
            'flex';
        }

        /*
         * Add main product with the
         * selected quantity.
         */
        const formData =
          new FormData(
            this.form
          );

        const mainResponse =
          await fetch(
            theme.routes.cartAdd,
            {
              method: 'POST',
              headers: {
                Accept:
                  'application/json',

                'X-Requested-With':
                  'XMLHttpRequest'
              },
              body:
                formData
            }
          );

        const mainData =
          await mainResponse.json();

        const mainError =
          this.getErrorMessage(
            mainData,
            'Main product could not be added.'
          );

        if (
          !mainResponse.ok ||
          mainData.status
        ) {
          this.setErrorMsgState(
            mainError
          );

          alert(
            Array.isArray(
              mainError
            )
              ? mainError.join('\n')
              : mainError
          );

          return;
        }

        /*
         * Fetch the REAL cart after the
         * main product has been added.
         *
         * This includes the selected quantity.
         */
        const tempCart =
          await this.getCart();

        console.log(
          '[Free Gift] Buy Now cart:',
          tempCart
        );

        /*
         * Add exactly ONE matching free gift.
         *
         * Gift 2 is checked first.
         * Gift 1 is fallback.
         */
        await this.addFreeGiftIfNeeded(
          tempCart,
          mainData.variant_id
        );

        /*
         * Only redirect after the gift
         * operation has finished.
         */
        window.location.href =
          '/checkout';
      } catch (error) {
        console.log(
          'Buy Now error:',
          error
        );

        alert(
          'Something went wrong. Please try again.'
        );
      } finally {
        buyNowBtn.removeAttribute(
          'aria-disabled'
        );

        if (loader) {
          loader.style.display =
            'none';
        }
      }
    }

    /*
     * ============================================================
     * NORMAL ADD TO CART
     * ============================================================
     *
     * IMPORTANT:
     *
     * There is NO addFreeGiftIfNeeded() call here.
     *
     * Your existing CartWatcher /
     * addAutoFreeGiftIfNeeded() handles the gift.
     *
     * This is what prevents the duplicate gift.
     * ============================================================
     */
    async handleSubmit(evt) {
      if (
        evt.target.id ===
        'product-signup_form'
      ) {
        return;
      }

      evt.preventDefault();

      if (
        this.submitBtn.getAttribute(
          'aria-disabled'
        ) === 'true'
      ) {
        return;
      }

      if (
        theme.settings
          .vibrateOnATC &&
        window.navigator.vibrate
      ) {
        window.navigator.vibrate(
          100
        );
      }

      this.errorMsg = null;

      this.setErrorMsgState();

      this.submitBtn.setAttribute(
        'aria-disabled',
        'true'
      );

      this.submitBtn.classList.add(
        'is-loading'
      );

      const formData =
        new FormData(
          this.form
        );

      let sections =
        'cart-icon-bubble';

      if (this.cartDrawer) {
        sections += `,${this.cartDrawer
          .closest(
            '.shopify-section'
          )
          .id.replace(
            'shopify-section-',
            ''
          )}`;
      }

      formData.append(
        'sections_url',
        window.location.pathname
      );

      formData.append(
        'sections',
        sections
      );

      const fetchRequestOpts = {
        method: 'POST',

        headers: {
          Accept:
            'application/javascript',

          'X-Requested-With':
            'XMLHttpRequest'
        },

        body:
          formData
      };

      try {
        const oldCartData =
          await this.getCart();

        const response =
          await fetch(
            theme.routes.cartAdd,
            fetchRequestOpts
          );

        const data =
          await response.json();

        const error =
          this.getErrorMessage(
            data
          );

        if (data.status) {
          this.setErrorMsgState(
            error
          );
        }

        if (
          !response.ok ||
          data.status
        ) {
          throw new Error(
            Array.isArray(error)
              ? error.join(', ')
              : error
          );
        }

        /*
         * IMPORTANT:
         *
         * Do NOT add a free gift here.
         *
         * CartWatcher will detect the main-product
         * cart change and call:
         *
         * addAutoFreeGiftIfNeeded()
         *
         * exactly once.
         */

        this.refreshCartUI(
          data
        );

        if (
          theme.settings
            .afterAtc ===
          'page'
        ) {
          setTimeout(() => {
            window.location.href =
              theme.routes.cart;
          }, 300);

          return;
        }

        /*
         * Existing line-item event logic.
         */
        const itemInOldCart =
          oldCartData.items.find(
            (item) =>
              Number(
                item.variant_id
              ) ===
              Number(
                data.variant_id
              )
          );

        if (itemInOldCart) {
          this.dispatchEvent(
            new CustomEvent(
              'on:line-item:change',
              {
                bubbles: true,

                detail: {
                  cart: null,

                  variantId:
                    data.variant_id,

                  oldQuantity:
                    itemInOldCart.quantity,

                  newQuantity:
                    itemInOldCart.quantity +
                    (data.quantity ||
                      1)
                }
              }
            )
          );
        } else {
          this.dispatchEvent(
            new CustomEvent(
              'on:cart:add',
              {
                bubbles: true,

                detail: {
                  cart: null,

                  variantId:
                    data.variant_id
                }
              }
            )
          );
        }
      } catch (error) {
        console.log(error);

        this.dispatchEvent(
          new CustomEvent(
            'on:cart:error',
            {
              bubbles: true,

              detail: {
                error:
                  this.errorMsg
                    ?.textContent ||
                  error.message
              }
            }
          )
        );

        if (this.cartDrawer) {
          this.cartDrawer.refresh(
            true
          );
        }
      } finally {
        this.submitBtn.classList.add(
          'is-success'
        );

        this.submitBtn.removeAttribute(
          'aria-disabled'
        );

        setTimeout(() => {
          this.submitBtn.classList.remove(
            'is-loading'
          );

          this.submitBtn.classList.remove(
            'is-success'
          );
        }, 1400);
      }
    }

    /*
     * ============================================================
     * CART ICON
     * ============================================================
     */
    static updateCartIcon(
      response
    ) {
      const cartIconBubble =
        document.getElementById(
          'cart-icon-bubble'
        );

      if (
        cartIconBubble &&
        response.sections &&
        response.sections[
          'cart-icon-bubble'
        ]
      ) {
        cartIconBubble.innerHTML =
          response.sections[
            'cart-icon-bubble'
          ];
      }
    }

    /*
     * ============================================================
     * ERROR STATE
     * ============================================================
     */
    setErrorMsgState(
      error = false
    ) {
      this.errorMsg =
        this.errorMsg ||
        this.querySelector(
          '.js-form-error'
        );

      if (!this.errorMsg) {
        return;
      }

      this.errorMsg.hidden =
        !error;

      if (error) {
        this.errorMsg.innerHTML =
          '';

        const errorArray =
          Array.isArray(error)
            ? error
            : [error];

        errorArray.forEach(
          (err, index) => {
            if (index > 0) {
              this.errorMsg.insertAdjacentHTML(
                'beforeend',
                '<br>'
              );
            }

            this.errorMsg.insertAdjacentText(
              'beforeend',
              err
            );
          }
        );
      }
    }
  }

  customElements.define(
    'product-form',
    ProductForm
  );
}